var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-wrap"},[_c('div',{staticClass:"header-text"},[_vm._v("总览报表")]),_c('allreport-filter',{ref:"filterRef",on:{"handleSearch":_vm.handleSearch,"downloadFile":_vm.downloadFile}}),_c('div',{staticClass:"table-wrap"},[_c('allreport-table',{ref:"tableRef",on:{"closeDownLoadLoading":_vm.closeDownLoadLoading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }